module.exports = __webpack_public_path__ + "img/2_273.6e7c8151.png";